export type Graph = {
    numberOfConversations: number;
    availableActions: string[];
    conversationsId: string[];
    exist : boolean;
    links : Link[];
}
export class MonitoringGraphOptions{
  startDate: string;
  endDate: string | undefined;
  events: string;
  actions: string;
  constructor(start:string, end:string | undefined, events: string, actions: string) {
    this.startDate = start;
    this.endDate = end;
    this.events = events;
    this.actions = actions;
  }
}
export class MonitoringPathOptions{
  conversationId : string;
  events: string;
  actions: string;
  constructor(conversationId : string, events: string, actions: string){
    this.events = events
    this.conversationId = conversationId
    this.actions = actions
  }
}

export type Link = {
    parent: string;
    children: string;
    stats: number;
};

export type Event = {
    id: string;
    name: string;
};

export type GraphState = {
   events : Event[] 
   graph: Graph;
   path : Graph;
}